import { render } from "./WorkView.vue?vue&type=template&id=231aed97"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__